module.exports = __webpack_public_path__ + "img/slide2.09c85d87.png";